import Vue from 'vue'
import Vuex from 'vuex'
import state from './state'
import actions from './actions'
import getters from './getters'
import mutations from './mutations'
// import createLogger from 'vuex/dist/logger'

Vue.use(Vuex)

// include modules only if you need them in state for the full session..
// otherwise let's dynamically register modules as needed and free up the state
export default new Vuex.Store({
  //strict: process.env.NODE_ENV !== 'production',
  state: state ,
  getters: getters,
  mutations: mutations,
  actions:actions,
  // plugins: process.env.NODE_ENV !== 'production' ? [createLogger()]: [],
})
